// components/pdf/AutoText.js
import React from 'react';
import { Text } from '@react-pdf/renderer';

// Utility: Detect Marathi (Devanagari) characters
const isMarathi = (text) => /[\u0900-\u097F]/.test(text);

// AutoText component
export const AutoText = ({
  children,
  marathiFont = 'NotoSans',
  englishFont = 'Arial',
  style: userStyle = {},
}) => {
  const selectedFont = isMarathi(children) ? marathiFont : englishFont;
  const fontStyle = { fontFamily: selectedFont };

  return (
    <Text style={[fontStyle, userStyle]}>
      {children}
    </Text>
  );
};
